import { connect } from 'react-redux';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';
import { selectQueueState } from '../../../../../app/utils/reselect';
import { getAllQueues } from '../../../actions/queues';
import { whatsappActions } from '../../../actions/whatsapp';
import { WhatsAppSignup } from '../../../components/sections/messaging/WhatsAppSignup';
const mapStateToProps = (state) => {
    return {
        queues: selectQueueState(state).queues,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        whatsappSignup: bindActionToPromise(dispatch, whatsappActions.whatsappSignup),
        getAllQueues: () => dispatch(getAllQueues()),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(WhatsAppSignup);
